import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import UserIcon from "../Dropdown/UserDropdown";
import Badge from "@mui/material/Badge";

const drawerWidth = 280;

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: "#fff",
  boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
  position: "fixed",
  width: `calc(100% - ${open ? drawerWidth : 0}px)`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: open ? drawerWidth : 0,
  ...(open && {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "fixed",
    height: "100vh",
    top: 0,
    left: 0,
    whiteSpace: "nowrap",
    background: "#ffffff",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    zIndex: theme.zIndex.drawer,
    borderRight: "1px solid #e0e0e0",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

export const TextTypography = () => {
  return (
    <Typography
      component="h1"
      variant="h6"
      color="inherit"
      noWrap
      sx={{ flexGrow: 1 }}
    >
      {/* <h3 style={{color:"blue", paddingRight:"-50px"}}>Hey! Naseer </h3> */}
    </Typography>
  );
};

export const StatusText = (props) => {
  return (
    <IconButton
      edge="start"
      color="inherit"
      aria-label="open drawer"
      font-size="14px"
    >
      <Typography
        component="h5"
        variant="h7"
        color={props.colors}
        fontSize="15px"
        noWrap
        sx={{ flexGrow: 1 }}
      >
        {props.status}
      </Typography>
    </IconButton>
  );
};

export const UserIcons = () => {
  return (
    <IconButton color="inherit">
      <Badge color="secondary">
        <UserIcon />
      </Badge>
    </IconButton>
  );
};
